import { Component, OnInit, ViewEncapsulation, Input, Renderer2, ElementRef } from '@angular/core';
export class RightSideComponent implements OnInit {

     background: string;
/**
 * @param {?} _render
 * @param {?} _ref
 */
constructor(
private _render: Renderer2,
private _ref: ElementRef
    ) { }
/**
 * @return {?}
 */
ngOnInit() {
        this._render.setStyle(this._ref.nativeElement, 'background-image', 'url(' + this.background + ')'); // coloring row with class
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'hd-right-side',
  template: `
    <ng-content></ng-content>
  `,
  styles: [`
    :host {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex: 50%;
          -ms-flex: 50%;
              flex: 50%;
      border: none;
      height: 100vh;
      background-attachment: fixed;
      background-size: cover;
      overflow: hidden; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'background': [{ type: Input },],
};
}

function RightSideComponent_tsickle_Closure_declarations() {
/** @type {?} */
RightSideComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RightSideComponent.ctorParameters;
/** @type {?} */
RightSideComponent.propDecorators;
/** @type {?} */
RightSideComponent.prototype.background;
/** @type {?} */
RightSideComponent.prototype._render;
/** @type {?} */
RightSideComponent.prototype._ref;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
